import type { ICreateLinkDocumentParams, IGoogleSheetMetaData, IUploadAndSaveDocument } from '@condo/domain';
import { omit } from 'lodash-es';
import { getClient } from './api-client';

export const generatePDFFromHTML = async (opts: { html: string; filename: string }) => {
    const response = await getClient('basecamp').post(
        '/document/generate-pdf-from-html',
        { html: opts.html, filename: opts.filename },
        { responseType: 'blob' },
    );

    // documentPreviewUrl.value = URL.createObjectURL(data);
    const htmlFile = new File([response.data], opts.filename, { type: 'application/pdf' });

    return htmlFile;
};

export const downloadFolder = async (folderId: number, params: { folderName: string; estateId?: number; mfhId?: number }) => {
    const response = await getClient('basecamp').post(`/documents-folder/download/${folderId} `, omit(params, ['folderName']), { responseType: 'blob' });

    const zipFile = new File([response.data], params.folderName, { type: 'application/zip' });

    return zipFile;
};

export const createLinkDocument = async (params: ICreateLinkDocumentParams): Promise<IUploadAndSaveDocument> => {
    const { data } = await getClient('basecamp').post('/link-documents', params);
    return data;
};

export const getGoogleSheetMetaData = async (spreadsheetUrl: string): Promise<Partial<IGoogleSheetMetaData>[]> => {
    const response = await getClient('basecamp').get('/google-sheet-metadata', { params: { spreadsheetUrl } });
    return response.data.googleSheetMetaData;
};
